import React from 'react';
import useIsOnline from '../../hooks/useIsOnline/useIsOnline';
import useParticipantNetworkQualityLevel from '../../hooks/useParticipantNetworkQualityLevel/useParticipantNetworkQualityLevel';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import Snackbar from '../Snackbar/Snackbar';

const SLOW_CONNECTION_THRESHOLD = 2;

export default function ConnectionQualityNotification() {
  const { room } = useVideoContext();
  const isOnline = useIsOnline();
  const roomState = useRoomState();
  const networkQualityLevel = useParticipantNetworkQualityLevel(room?.localParticipant);

  if (!room) {
    return null;
  }

  const isSlowConnection =
    isOnline &&
    roomState === 'connected' &&
    typeof networkQualityLevel === 'number' &&
    networkQualityLevel <= SLOW_CONNECTION_THRESHOLD;

  return (
    <Snackbar
      variant="warning"
      headline="Conexao lenta:"
      message="Sua internet esta instavel. O video pode travar ou aparecer em branco por alguns instantes."
      open={isSlowConnection}
    />
  );
}
